module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/home-2-bg-575a1272e4887a6a9f3ef193c1706d30.svg";